// extracted by mini-css-extract-plugin
export var orderDetails = "_rv-2";
export var orderImage = "_rv-1";
export var orderMeta = "_rv-3";
export var orderSummary = "_rv-0";
export var rightArrow = "_rv-4";